import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseElement } from '../../base-element';

@Component({
  selector: 'checkbox-single',
  templateUrl: './single-checkbox.component.html',
  providers: [ {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SingleCheckboxComponent),
    multi: true
  } ]
})
export class SingleCheckboxComponent extends BaseElement<string> implements OnInit {

  @Input() onValue: any;
  @Input() offValue: any;
  @Input() placeholder: string;

  ngOnInit(): void {
    if (this.label && this.isRequired) {
      this.label += ' *';
    }
  }

  onChange(): void {
    this.toggleInvalidClass(false);
    // if (this.change) {
    //   this.change.emit(this.model);
    // }
  }

  protected toggleInvalidClass(flag: boolean): void {
    this.customClass = Object.assign(this.customClass, { 'is-invalid': flag });
  }
}


